export const CHANNEL_CHANGE_RECEIVED = 'CHANNEL_CHANGE_RECEIVED';